/**
 * Usage:
 *
 * Step 1: Somewhere in JS...
 *   import Alpine from "alpinejs";
 *   import spine from "./swiper";
 *   Alpine.data('swiper', swiper);
 *   Alpine.start();
 *
 * Step 2: Somewhere in markup...
 *   <div x-data="...swiper({
            slidesPerView:1,
            })}" />
 *
 * @returns {{init(): void, el: null, selector: null}}
 */


import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay, EffectFade} from 'swiper/modules';
import 'swiper/css/bundle';

// initialize any additional classes such as { Pagination }
Swiper.use([Pagination, Navigation, Autoplay, EffectFade]);

export default (opts = {}) => ({
  options: {
    centerInsufficientSlides: true,
    ...opts
  },
  swiper: null,

  init() {
    if (this.swiper !== null) {
      return;
    }
    this.swiper = new Swiper(this.$el, this.options);
  },

  /*
  Somewhere in twig x-on:click="slideTo({{ loop.index }})"
   */

  slideTo(index) {
    if (this.swiper && index) {
      this.swiper.slideTo(index);
    }
  }

});
